<script>
import List from "@/components/molecules/list";
import ListItem from "@/components/molecules/list/list-item";
import LinkTo from "@/components/atoms/link-to";

export default {
  name: "AchatsExpressMobile",
  components: { List, ListItem, LinkTo },
  methods: {
    redirect(slug) {
      navigateToInternal(slug);
    }
  }
};
</script>

<template>
  <div>
    <list class="c-header-achats-express-mobile">
      <ListItem class="c-header-achats-express-mobile__item">
        <LinkTo
          variant="text"
          hover-color="primary-light"
          no-underline
          @click="redirect('/mon-compte/mes-listes-de-courses')"
        >
          Mes listes
        </LinkTo>
      </ListItem>
      <ListItem class="c-header-achats-express-mobile__item">
        <LinkTo
          variant="text"
          hover-color="primary-light"
          no-underline
          @click="redirect('/mon-compte/mes-produits-habituels')"
        >
          Mes Produits habituels
        </LinkTo>
      </ListItem>
    </list>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/header-achats-express-mobile.scss";
</style>
